interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  articleAuthor?: string;
  articleSection?: string;
  articleTags?: string[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = "website",
  ogImage,
  articlePublishedTime,
  articleModifiedTime,
  articleAuthor,
  articleSection,
  articleTags,
}: SEOHeadProps) {
  const fullTitle = `${title} | 51爆料`;
  const baseUrl = "https://www.51baoliao.com";
  const fullCanonical = canonicalUrl.startsWith("http") ? canonicalUrl : `${baseUrl}${canonicalUrl}`;
  const defaultImage = `${baseUrl}/og-default.jpg`;

  useEffect(() => {
    document.title = fullTitle;
    const metaTags = [
      { name: "description", content: description },
      { name: "keywords", content: keywords },
      { property: "og:title", content: fullTitle },
      { property: "og:description", content: description },
      { property: "og:type", content: ogType },
      { property: "og:url", content: fullCanonical },
      { property: "og:image", content: ogImage || defaultImage },
      { property: "og:site_name", content: "51爆料" },
      { property: "og:locale", content: "zh_CN" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: fullTitle },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: ogImage || defaultImage },
    ];

    const existingMeta = document.head.querySelectorAll("meta[name], meta[property]");
    existingMeta.forEach((el) => {
      const name = el.getAttribute("name") || el.getAttribute("property");
      if (metaTags.some((m) => (m.name || m.property) === name)) {
        el.remove();
      }
    });

    metaTags.forEach(({ name, property, content: c }) => {
      if (c) {
        const meta = document.createElement("meta");
        if (name) meta.setAttribute("name", name);
        if (property) meta.setAttribute("property", property);
        meta.setAttribute("content", c);
        document.head.appendChild(meta);
      }
    });

    let canonicalEl = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (!canonicalEl) {
      canonicalEl = document.createElement("link");
      canonicalEl.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute("href", fullCanonical);

    if (articlePublishedTime) {
      let metaPub = document.querySelector("meta[property='article:published_time']");
      if (!metaPub) {
        metaPub = document.createElement("meta");
        metaPub.setAttribute("property", "article:published_time");
        document.head.appendChild(metaPub);
      }
      metaPub.setAttribute("content", articlePublishedTime);
    }
    if (articleModifiedTime) {
      let metaMod = document.querySelector("meta[property='article:modified_time']");
      if (!metaMod) {
        metaMod = document.createElement("meta");
        metaMod.setAttribute("property", "article:modified_time");
        document.head.appendChild(metaMod);
      }
      metaMod.setAttribute("content", articleModifiedTime);
    }
    if (articleAuthor) {
      let metaAuth = document.querySelector("meta[property='article:author']");
      if (!metaAuth) {
        metaAuth = document.createElement("meta");
        metaAuth.setAttribute("property", "article:author");
        document.head.appendChild(metaAuth);
      }
      metaAuth.setAttribute("content", articleAuthor);
    }
    if (articleSection) {
      let metaSec = document.querySelector("meta[property='article:section']");
      if (!metaSec) {
        metaSec = document.createElement("meta");
        metaSec.setAttribute("property", "article:section");
        document.head.appendChild(metaSec);
      }
      metaSec.setAttribute("content", articleSection);
    }
    if (articleTags && articleTags.length > 0) {
      document.head.querySelectorAll("meta[property='article:tag']").forEach((el) => el.remove());
      articleTags.forEach((tag) => {
        const metaTag = document.createElement("meta");
        metaTag.setAttribute("property", "article:tag");
        metaTag.setAttribute("content", tag);
        document.head.appendChild(metaTag);
      });
    }

    return () => {
      document.title = "51爆料";
    };
  }, []);

  return null;
}